import {
  getImageBase64,
  getBackground,
  getThemePic,
} from "@/views/home/slidePPT/use/methods";
import { pathToBase64 } from "@/utils";

export default async function (data) {
  const node = data.node;
  const catalogueList = node.list || node.children;
  const color = data.color;
  let htmlText = "<ul>";
  for (let i = 0; i < catalogueList.length; i++) {
    const item = catalogueList[i];
    htmlText += `<li style=\"text-align: left;\"><span style=\"font-size: 24.49px;font-family: Microsoft Yahei;\">${item}</span></li>`;
  }
  htmlText += "</ul>";
  const id = Math.random().toString(36).slice(-8);
  const background = await getBackground(data?.customTheme);
  const ex1 = await getThemePic(data?.customTheme, "ex-1");
  const ex2 = await getThemePic(data?.customTheme, "ex-2");
  const ex3 = await getThemePic(data?.customTheme, "ex-3");
  const ex4 = await getThemePic(data?.customTheme, "ex-4");

  return {
    id: id,
    elements: [
      {
        type: "image",
        id: "2KTOFGdszQ",
        src: ex1,
        width: 1000,
        height: 562.5,
        left: 0,
        top: 0,
        fixedRatio: true,
        rotate: 0,
        flipH: false,
        flipV: false,
      },
      {
        type: "image",
        id: "Z79Ovateiu",
        src: ex2,
        width: 909.05,
        height: 495.68,
        left: 45.48,
        top: 33.41,
        fixedRatio: true,
        rotate: 0,
        flipH: false,
        flipV: false,
      },
      {
        type: "image",
        id: "QAT0Pjp1OM",
        src: ex3,
        width: 181.44,
        height: 22.47,
        left: 606.82,
        top: 66.39,
        fixedRatio: true,
        rotate: 0,
        flipH: false,
        flipV: false,
      },
      {
        type: "image",
        id: "W57OkS-tPx",
        src: ex4,
        width: 407.08,
        height: 407.08,
        left: 547.44,
        top: 229.48,
        fixedRatio: true,
        rotate: 0,
        flipH: false,
        flipV: false,
      },
      {
        type: "text",
        id: "F-sMJfofgj",
        width: 126.51,
        height: 44.21875,
        left: 126.9,
        top: 68.13,
        rotate: 0,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333333",
        content:
          '<p style="text-align: left;"><span style="font-size: 8.16px;font-family: 微软雅黑;font-weight: bold;letter-spacing: 0px;vertical-align: sub; font-size: smaller;">LOGO&nbsp;HERE</span></p>',
        lineHeight: 1,
        outline: {
          color: "#000",
          width: 0,
          style: "solid",
        },
        fill: "",
        vertical: false,
      },
      {
        type: "shape",
        id: "4f9XoVs_r4",
        width: 37.09,
        height: 49.07,
        left: 86.27,
        top: 54.26,
        viewBox: [37.09, 49.07],
        path: " M12.52585180324682,15.061927760483426 C6.222519928064549,19.74025380730025 0,36.7419752945126 8.081194711772142,42.78956750137337 C16.324013317779723,49.065370734908136 19.798927043841747,29.66743346761887 26.829566443083507,29.21101141427089 C37.09268372703413,28.526378334248914 33.05208637114806,0 12.52585180324682,15.061927760483426z",
        fill: "none",
        fixedRatio: false,
        rotate: 96,
        outline: {
          color: "#4472C4",
          width: 0,
          style: "solid",
        },
        text: {
          content:
            '<p style="text-align: left;"><span style="font-size: 18.37px;font-family: 等线;">&nbsp;</span></p>',
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333333",
          align: "top",
        },
        flipH: true,
        flipV: false,
        special: true,
      },
      {
        type: "shape",
        id: "O-Y1L7bgSW",
        width: 49.43,
        height: 64.87,
        left: 67.25,
        top: 45.19,
        viewBox: [49.43, 64.87],
        path: " M16.693029537565977,19.914839315143745 C8.292666286403742,26.10050910242324 0,48.580138329365795 10.769696475849017,56.57624805438564 C21.754786881215015,64.87409776902886 26.38575636583009,39.226198651040704 35.75539229981874,38.622718671793926 C49.43290682414698,37.717498702923756 44.048058586222474,0 16.693029537565977,19.914839315143745z",
        fill: "#0070c0",
        fixedRatio: false,
        rotate: 284,
        outline: {
          color: "#000",
          width: 0,
          style: "solid",
        },
        text: {
          content:
            '<p style="text-align: left;"><span style="font-size: 18.37px;font-family: 等线;">&nbsp;</span></p>',
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333333",
          align: "top",
        },
        flipH: true,
        flipV: false,
        special: true,
      },
      {
        type: "text",
        id: "SxACQ0xFoo",
        width: 53.69030989272944,
        height: 183.1875,
        left: 665.0652800953516,
        top: 88.86,
        rotate: 0,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333333",
        content:
          '<p style="text-align: center;"><strong><span style="font-size: 48px;"><span style="font-family: 华文中宋;"><span style="color: #0070C0;"><sub>目</sub>&nbsp;<sub>录</sub></span></span></span></strong></p>',
        lineHeight: 1,
        outline: {
          color: "#000",
          width: 0,
          style: "solid",
        },
        fill: "",
        vertical: false,
      },
      {
        type: "text",
        id: "eR9-7X_IWN",
        width: 51.921875,
        height: 131.16,
        left: 725.46,
        top: 133.6,
        rotate: 0,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333333",
        content:
          '<p style=""><span style="font-size: 28px;"><span style="font-family: 华文中宋;"><span style="color: #0070C0;"><sub>contents</sub></span></span></span></p>',
        lineHeight: 1,
        outline: {
          color: "#000",
          width: 0,
          style: "solid",
        },
        fill: "",
        vertical: true,
      },
      {
        type: "text",
        id: "8bJptIMrwU",
        width: 49.61,
        height: 40,
        left: 0,
        top: 0,
        rotate: 0,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333333",
        content:
          '<p style="text-align: left;"><span style="font-size: 1.38px;font-family: 微软雅黑;">行业</span><span style="font-size: 1.38px;font-family: 微软雅黑;">PPT</span><span style="font-size: 1.38px;font-family: 微软雅黑;">模板</span><span style="font-size: 1.38px;font-family: 微软雅黑;">http://www.1ppt.com/hangye/</span></p>',
        lineHeight: 1,
        outline: {
          color: "#000",
          width: 0,
          style: "solid",
        },
        fill: "",
        vertical: false,
      },
      {
        type: "text",
        id: "V33g5l5bYX",
        width: 490.77028871391076,
        height: 190,
        left: 168.38435695538055,
        top: 180.3059317585302,
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",
        fixedRatio: false,
        content: htmlText,
        rotate: 0,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333",
      },
    ],

    background,
  };
}
